// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const config = {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
  apiKey: window?.SmartSearchConfig?.apiKey,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
  apiHost: window?._QONizer?.domains?.restApiDomain || 'restv3api.quarticon.com',
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
  customerSymbol: window?.SmartSearchConfig?.customerSymbol,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
  searchId: window?.SmartSearchConfig?.searchId
  
}

